import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'playbook-search-explorer-empty',
  templateUrl: './search-explorer-empty.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styles: [':host{ height: 100%}'],
})
export class SearchExplorerEmptyComponent {}
